export async function copy(text: string) {
  /* Не работает в небезопасном контексте (http, ws и тд). Для проверки можно запустить сервер на http://0.0.0.0:8000 */
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);

    return;
  }

  const input = document.createElement('input');

  document.body.appendChild(input);

  input.value = text;
  input.select();

  /* DEPRECATED */
  document.execCommand('copy', false);
  input.remove();
}
